export default "__VITE_ASSET__4322be8b__"